export const NAMESPACE = 'user-activity';

// CASE MANAGER
// ==========================================================================

export const UPDATE_ACTIVITY_QUERIES = `${NAMESPACE}/UPDATE_ACTIVITY_QUERIES`;
export const SET_USER_ACTIVITIES = `${NAMESPACE}/SET_USER_ACTIVITIES`;
